import React from 'react';
import { TestimonialCard } from './TestimonialCard';
export function EarlyTestimonials() {
  const testimonials = [{
    initials: 'MG',
    rating: 5,
    text: 'En 3 semanas tuve más conversaciones reales que en todo el año.',
    author: 'Martín G., Córdoba'
  }, {
    initials: 'LP',
    rating: 5,
    text: 'Dejé de actuar. Empecé a ser yo. Y ahí todo cambió.',
    author: 'Lucas P., Rosario'
  }, {
    initials: 'RM',
    rating: 5,
    text: 'Pensé que era un problema mío. Era solo que no tenía el sistema.',
    author: 'Rodrigo M., Buenos Aires'
  }];
  return <section className="py-24 md:py-32 px-4 bg-bg-primary pt-[9px] pb-[9px]" data-id="element-82">
      <div className="max-w-6xl mx-auto" data-id="element-83">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-84">
          {testimonials.map((testimonial, i) => <TestimonialCard key={i} {...testimonial} data-id="element-85" />)}
        </div>
      </div>
    </section>;
}